import React, { Component } from 'react'
import FormViewer from '../../../../components/FormViewer'
import { translate } from '../../../../utils/useful'
import ButtonAnimated from '../../../../components/buttons/ButtonAnimated'

export default class BookingUserForm extends Component {
    state = {
        header: [
            { key: 'customername', type: 'TextInput', col: '6', information: { label: '{{lang}}name', filter: {}, isSearchable: true, placeholder: '{{lang}}name', required: true, } },
            { key: 'customerfamily', type: 'TextInput', col: '6', information: { label: '{{lang}}family', filter: {}, isSearchable: true, placeholder: '{{lang}}family', required: true, } },
            { key: 'customernumber', type: 'NumberInput', col: '6', information: { label: '{{lang}}number', filter: {}, isSearchable: true, placeholder: '{{lang}}number', required: true, } },
            // { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Scheduler', address: 'getAvailableTimes', filter: {}, inputClass: 'aa', isSearchable: true, placeholder: '{{lang}}select', required: false, } },
        ],
    }
    handleStep = () => {
        let data = this.form.getForm()
        if (data != null) {
            this.props.setData(data, () => {
                this.props.postInformation()
            })
        }
    }
    render() {
        return (
            <div className='h-100'>
                <div className='mt-2'>
                    <FormViewer initData={this.props.data} ref={el => this.form = el} headers={this.state.header} theme={"modern"} inputClass={"modern-input-booking"} />
                </div>
                <div style={{ position: 'fixed', bottom: 10, right: 10 }}>
                    <ButtonAnimated title={'Submit'}  onClick={() => {this.props.changePage('success', 1) }} />
                </div>
            </div>
        )
    }
}
